import { render, staticRenderFns } from "./activar_desactivar_permisovacacion.vue?vue&type=template&id=2e63a904"
import script from "./activar_desactivar_permisovacacion.vue?vue&type=script&lang=js"
export * from "./activar_desactivar_permisovacacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports